import { createSelector } from 'reselect';

const getEvents = state => state.event;

export const getMainEvent = state => {
    if (typeof state.event.events === 'object' && state.event.events !== null && !!Object.keys(state.event.events).length) {
        return Object.values(state.event.events)[0];
    }
    return null;
}

export const getSelectedEvent = state => {
    if (!!state.event?.childEvent) {
        return state.event.childEvent;
    }
    return getMainEvent(state);
}

export const getPriceLevels = createSelector(
    [getMainEvent],
    (event) => {
        let levels = {};
        if (Array.isArray(event?.price_levels)) {
            event.price_levels.map(pl => {
                levels[pl.price_level_id] = pl;
            });
        }
        return levels;
    }
)

export const getProducts = createSelector(
    [getMainEvent],
    (event) => {
        let products = {};
        if (Array.isArray(event?.products)) {
            event.products.map(product => {
                products[product.product_id] = product;
            });
        }
        return products;
    }
)

export const getBundles = createSelector(
    [getMainEvent],
    (event) => {
        let bundles = {};
        if (Array.isArray(event?.bundles)) {
            event.bundles.map(bn => {
                bundles[bn.id] = bn;
            });
        }
        return bundles;
    }
)

export const hasCoupons = createSelector([getEvents],(events) =>  {
    let hasCoupons = false;
    if(events?.childEvent && events?.childEvent?.event?.hasCoupons) {
        hasCoupons = true;
    }

    if(!hasCoupons && events && events?.events) {
        hasCoupons = Object.values(events.events)[0].event.hasCoupons;
    }

    return hasCoupons;
});

export const get_custom_get_seat_message = createSelector(
    [getMainEvent],
    (event) => {
        return event?.event?.custom_get_seat_message;
    }
)